import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=f4d9cac0&scoped=true&"
import script from "./not-found.ts?vue&type=script&lang=ts&"
export * from "./not-found.ts?vue&type=script&lang=ts&"
import style0 from "./not-found.scss?vue&type=style&index=0&id=f4d9cac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d9cac0",
  null
  
)

component.options.__file = "not-found.vue"
export default component.exports